import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ breakpoints }: Theme) =>
  createStyles({
    pageBody: {
      marginTop: 5,
    },

    titleCard: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: palette.darkGray,
      fontSize: 14,
      fontWeight: 500,
      zIndex: 2,
      margin: '10px 0px',
    },
    graphCard: {
      [breakpoints.up(775.1)]: {
        width: '75%',
      },
      [breakpoints.down(775)]: {
        width: '100%',
      },
    },
    containerGraph: {
      justifyContent: 'center',
      alignItems: 'center',
      [breakpoints.down('md')]: {
        marginLeft: 0,
        justifyContent: 'flex-start',
      },
      [breakpoints.down(775)]: {
        justifyContent: 'center',
      },
      [breakpoints.down(575)]: {
        justifyContent: 'flex-start',
      },
    },
  });

export const overrideCardGraph = (breakpoints): any => ({
  alignItems: 'center',
  display: 'flex',
  [breakpoints.down('md')]: {
    flexFlow: 'column-reverse',
    alignItems: 'baseline',
    justifyContent: 'flex-start',
    height: '100%',
  },
  [breakpoints.down(775)]: {
    flexFlow: 'unset',
    alignItems: 'center',
  },
  [breakpoints.down(575)]: {
    flexFlow: 'column-reverse',
    alignItems: 'baseline',
    justifyContent: 'flex-start',
    height: '100%',
  },
  minHeight: 130,
  '&:after': {
    content: '""',
    position: 'absolute',
    width: 180,
    height: 180,
    borderRadius: '50%',
    zIndex: 1,
    top: -75,
    right: -141,
  },
  '&:before': {
    content: '""',
    position: 'absolute',
    zIndex: 1,
    width: 180,
    height: 180,
    borderRadius: '50%',
    top: -125,
    right: -100,
    opacity: 0.5,
  },
});

export const overrideFilter = {
  text: {
    fontWeight: 500,
    fontSize: 14,
  },
  listItem: { '& .MuiTypography-body1': { fontSize: 14 } },
};
